<template>
  <faq-page v-if="supportPageMode === 'FAQ'" />
  <form-page v-else />
</template>

<script setup lang="ts">
import { getConfigValue } from '@/core/consts/config';
import FaqPage from '@/parts/support/components/FaqPage.vue';
import FormPage from '@/parts/support/components/FormPage.vue';

const supportPageMode = getConfigValue('supportPageMode');
</script>

<style lang="scss" scoped></style>
